var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUpLargeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 29,
    viewBox: "0 0 18 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.211098 8.38L8.56057 0.20624C8.76219 -0.0364261 9.12236 -0.0697348 9.36503 0.1318C9.39203 0.154258 9.41701 0.179156 9.43947 0.20624L17.7889 8.38C18.0559 8.62746 18.0717 9.04458 17.8243 9.31156C17.7016 9.44395 17.53 9.52024 17.3495 9.5226H13.3945V20.1133C13.3194 20.5559 12.9615 20.8959 12.5156 20.9483H5.48439C5.1328 20.9483 5.04499 20.5088 5.04499 20.1133V9.5226H0.650503C0.286463 9.5178 -0.00473595 9.21886 5.72205e-05 8.85482C0.0024128 8.67432 0.0787029 8.50272 0.211098 8.38Z",
    fill: "#60D394"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4776 22.2666H12.5088C12.8728 22.2666 13.168 22.5618 13.168 22.9258C13.168 23.2898 12.8728 23.585 12.5088 23.585H5.4776C5.11356 23.585 4.81841 23.2898 4.81841 22.9258C4.81841 22.5618 5.11348 22.2666 5.4776 22.2666Z",
    fill: "#60D394"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4776 24.9031H12.5088C12.8728 24.9031 13.168 25.1982 13.168 25.5623C13.168 25.9263 12.8728 26.2215 12.5088 26.2215H5.4776C5.11356 26.2215 4.81841 25.9263 4.81841 25.5623C4.81841 25.1982 5.11348 24.9031 5.4776 24.9031Z",
    fill: "#60D394"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4776 27.5398H12.5088C12.8728 27.5398 13.168 27.8349 13.168 28.199C13.168 28.563 12.8728 28.8582 12.5088 28.8582H5.4776C5.11356 28.8582 4.81841 28.563 4.81841 28.199C4.81841 27.8349 5.11348 27.5398 5.4776 27.5398Z",
    fill: "#60D394"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpLargeIcon);
export default __webpack_public_path__ + "static/media/ArrowUpLargeIcon.b23071192d7bc6f4425b42c2afb96599.svg";
export { ForwardRef as ReactComponent };